import { defineComponent } from 'vue';
import utils from '@utils/index';
import app from '@/widget/app';
import { hostPath } from '@utils/basePath';
export default defineComponent({
    props: {
        item: {
            default() {
                return {};
            },
            type: Object
        },
        size: {
            default: 'big',
            type: String
        },
        small: {
            default: false,
            type: Boolean
        }
    },
    methods: {
        toDetail(item) {
            if (utils.isApp()) {
                app.postMessage({
                    type: 'mall_detail',
                    id: item.productId
                });
            }
            else {
                window.open(`${hostPath}/mall/detail?productId=${item.productId}`);
            }
        }
    }
});
